module.exports = __webpack_public_path__ + "static/img/1.b3bc476.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/1.png
// module id = e1V8
// module chunks = 1